// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import getImageHost from '../utils/get-image-host'

function addParams(src, width, originalSize) {
  if (!src) {
    return ''
  }

  if (src.startsWith('//')) {
    src = src.replace('//', 'https://')
  }

  const imageHost = getImageHost()

  // Replace potential incorrect image host set in contentful
  src = src.replace('img.uswitch.com', imageHost)
  src = src.replace('img.money.co.uk', imageHost)
  src = src.replace('fs-img.confused.com', imageHost)

  src = src.replace('images.ctfassets.net', imageHost)
  src = src.replace('money.imgix.net', `${imageHost}/s3`)
  src = src.replace('uswitch-cms.imgix.net', `${imageHost}/s3`)
  src = src.replace('uswitch-contentful.imgix.net', imageHost)

  const url = new URL(src)
  !originalSize && url.searchParams.append('w', width)
  if (!url.pathname.endsWith('.svg')) {
    url.searchParams.append('auto', 'format,compress')
  }

  return url.toString()
}

// eslint-disable-next-line no-magic-numbers
const Image = ({ src, alt, width = 1152, originalSize = false, critical, ...props }) => (
  <img
    src={critical ? addParams(src, width) : undefined}
    data-src={critical ? undefined : addParams(src, width, originalSize)}
    alt={alt}
    title={props.title}
    className={`${!critical ? 'lazyload ' : ''}${props.className}`}
  />
)

export default Image
